'use client';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { StyledInnerBanner } from '@/components/common/ygen/sections/inner-banner/inner-banner.style';
import { CURSOR_HIDE, CURSOR_SHOW, CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';

const InnerBanner = ({ data, imageScroll }) => {

	const bannerImge = data?.images?.list?.find((f) => f?.banner === 'on');
	const pathname = usePathname()

	return (
		<StyledInnerBanner className={`InnerBanner ${pathname === '/tech-showcase' ? 'tech-showcase' : ''} ${imageScroll ? 'forImageScroll' : ''} ${bannerImge?.for_project === 'on' ? 'for_projects' : ''}`} data-scroll-section>

			{
				imageScroll ?
					<ImgParallax  banner={true} src={data?.images ? bannerImge?.full_path : ''} />

					:
					<ImgParallax parallax banner={true} src={data?.images ? bannerImge?.full_path : ''} />


			}
			<Container>
				<Row>
					<Col md={3}>
						<ul className={'d-flex justify-content-start breadcrumb-ygen'}>
							<li>
								<Link href={'/'}>
									Home
								</Link>
							</li>
							<li>/</li>
							<li>
								{
									data?.section_data?.subtitle &&
									<h1 className={``}>{reactHtmlParser(data?.section_data?.subtitle)}</h1>

								}
							</li>
						</ul>

					</Col>
					<Col md={{ md: 4, offset: 5 }} className={'d-flex justify-content-end'}>

						{
							data?.section_data?.short_desc &&
							<p className={``}>{reactHtmlParser(data?.section_data?.short_desc)}</p>

						}
					</Col>
				</Row>
			</Container>
		</StyledInnerBanner>
	);
};


export default React.memo(InnerBanner);
